interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51吃瓜app',
    url: 'http://shlvtian.cn/',
    description: '51吃瓜app是国内领先的娱乐八卦资讯聚合平台，提供最新明星爆料、网红黑料、聊天记录泄露等热门吃瓜内容。',
    email: 'hello@shlvtian.cn',
    telephone: '+86-400-888-5151',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      streetAddress: '望京科技园区A座15层',
      addressCountry: 'CN',
    },
    sameAs: ['http://shlvtian.cn/'],
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51吃瓜app',
    url: 'http://shlvtian.cn/',
    description: '51吃瓜app提供全网最新吃瓜爆料视频在线观看，覆盖网红反差、博主塌房、明星聊天记录泄露等热门资源。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://shlvtian.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getWebPageSchema(title: string, description: string, url: string, datePublished?: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
    datePublished,
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '51吃瓜app',
      url: 'http://shlvtian.cn/',
    },
  };
}

export function getBreadcrumbSchema(items: Array<{ name: string; url: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function getArticleSchema(
  title: string,
  description: string,
  url: string,
  datePublished: string,
  author: string,
  imageUrl: string,
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    url,
    datePublished,
    dateModified: datePublished,
    author: {
      '@type': 'Person',
      name: author,
    },
    image: imageUrl,
    publisher: {
      '@type': 'Organization',
      name: '51吃瓜app',
      url: 'http://shlvtian.cn/',
    },
    inLanguage: 'zh-CN',
  };
}

export function getFAQSchema(faqs: Array<{ question: string; answer: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}